import API from "./API"

const fetchAgts = () => API.get(`agts`)

export default { fetchAgts }
